import "./App.css";
import { BrowserRouter } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material";
import ApiController from "./api/ApiController";
import LoginPage from "./page/login";
import ArtikelPage from "./page/Artikel";
import ArtikelForm from "./page/artikel-page/Artikel-Form";

const theme = createTheme({
  typography: {
    fontFamily: "Calibri", // Replace 'YourDesiredFont'
    // fontFamily: 'Roboto Slab, Arial, sans-serif', // Replace 'YourDesiredFont'
    // You can also define specific font styles for variants like h1, body1, etc.
    // h1: {
    //   fontFamily: 'AnotherFont',
    // },
    body1: {
      fontSize: 20,
    },
    body2: {
      fontSize: 18,
    },
    caption: {
      fontSize: 15,
    },
    subtitle1: {
      fontSize: 18,
    },
    subtitle2: {
      fontSize: 15,
    },
  },
});
function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <ThemeProvider theme={theme}>
          {localStorage.getItem("token") !== null && localStorage.getItem("name")!==null? (
            <ApiController />
          ) : (
            <LoginPage />
          )}
            
        </ThemeProvider>
      </div>
    </BrowserRouter>
  );
}

export default App;
